import Grid from "components/primitives/Grid";
import Box from "@mui/material/Box";
import ExportAthleteData from "./ExportAthleteData";
import Constants from "config/Constants";
import LocalisedLoadingProvider from "../../../components/LocalisedLoadingProvider";
import Paper from "components/mui5/Paper";
import { useTranslation } from "react-i18next";
import ThemeProvider2024 from "components/MuiThemeProvider/ThemeProvider2024";
import { Page, PageHeaderActions, PageTitle } from "components/Layout";
import GlobalSearch from "components/GlobalSearch";
import MuiThemeProvider from "components/MuiThemeProvider";
import DataExportInfoCardAdornment from "./DataExportAthleteInfoCardAdornment";

function DataExportAthlete() {
  const { t } = useTranslation();
  return (
    <ThemeProvider2024>
      <Page
        header={
          <>
            <PageTitle endAdornment={<DataExportInfoCardAdornment />}>
              {t(Constants.routes.exportData.titleKey)}
            </PageTitle>
            <PageHeaderActions>
              <GlobalSearch />
            </PageHeaderActions>
          </>
        }
      >
        <MuiThemeProvider>
          <Grid container justifyContent="center" mt={2}>
            <Grid size={{ xs: 12, sm: 10, md: 8, lg: 6, xl: 4 }}>
              <Box sx={{ display: "inline-block", alignContent: "center" }}>
                <Paper>
                  <LocalisedLoadingProvider>
                    <Box sx={{ p: 3 }}>
                      <ExportAthleteData />
                    </Box>
                  </LocalisedLoadingProvider>
                </Paper>
              </Box>
            </Grid>
          </Grid>
        </MuiThemeProvider>
      </Page>
    </ThemeProvider2024>
  );
}
export default DataExportAthlete;
